import { render, staticRenderFns } from "./PermissionInfo.vue?vue&type=template&id=42cc331a&scoped=true"
import script from "./PermissionInfo.vue?vue&type=script&lang=js"
export * from "./PermissionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cc331a",
  null
  
)

export default component.exports